import React from 'react';
import { Col, Card } from 'shards-react';
import { ERegion } from '@opu/utils';
import Loading from '../UI/loading';
import Table from '../UI/Table/Table';
import { useHistory } from 'react-router-dom';

import { LinearProgress } from '@material-ui/core';
import useForm from './useForm';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import { EstablishmentContracts } from '../../views/contract/listContractByEstablishment';
import Modal from '../UI/modal/Modal';

export default function Nord({ displayOptions }) {
  const [establishementId, setEstablishmentId] = React.useState('');

  const history = useHistory();
  const [query, setQuery] = React.useState({ page: null, keyword: '', limit: 10, region: 'nord' });
  // const handleOpen = (establishmentId) => history.push(`/contract/establishment/${establishmentId}/nord`);
  const [isDetailsModalOpen, setIsDetailsModalOpen] = React.useState(false);
  const handleOpen = (establishmentId) => {
    setEstablishmentId(establishmentId);
    setIsDetailsModalOpen(true);
  };
  const { attributes, actions, getEstablishmentByRegion } = useForm({ detailsAction: true }, handleOpen);
  const { t } = useTranslation();
  const [data, setData] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const getData = () => {
    setLoading(true);
    getEstablishmentByRegion(query)
      .then((res) => {
        setData({
          region: ERegion.Nord,
          listEstablishment: res.data.items,
          totalPages: res.data.totalPages,
          totalItems: res.data.totalItems,
        });
        setLoading(false);
      })
      .catch((error) => {
        console.error({ error });
        Swal.fire(t('contract.ERROR_GET_CONTRACTS'), '', 'error');
        setLoading(false);
      });
  };
  React.useEffect(() => {
    getData();
  }, [query]);
  //   if (loading) return <LinearProgress />;
  return (
    <>
      <Modal
        open={isDetailsModalOpen}
        setOpen={setIsDetailsModalOpen}
        body={<EstablishmentContracts establishmentId={establishementId} />}
        className="details-modal"
      />
      <Col>
        <Card small className="mb-4">
          <Table
            title={ERegion.Nord}
            attributes={attributes}
            actions={actions}
            data={data?.listEstablishment}
            loading={loading}
            search={getEstablishmentByRegion}
            numberOfPage={data?.totalPages}
            query={query}
            setQuery={setQuery}
            textButton={displayOptions.addButton && t('contract.add')}
            linkButton={displayOptions.addButton && '/contract/add'}
            pdfTitle="Liste des Etablissements - Nord"
          />
        </Card>
      </Col>
    </>
  );
}
